import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da65d076"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "single-message" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "watermark" }, null, -1))
const _hoisted_3 = { class: "single-message-container" }
const _hoisted_4 = { class: "fb-form-heading title" }
const _hoisted_5 = { class: "fb-form-heading subtitle" }
const _hoisted_6 = { class: "fb-form-heading trailer-number" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "message-footer text-center full-screen" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrailerWithWarning = _resolveComponent("TrailerWithWarning")!
  const _component_ReturnOptions = _resolveComponent("ReturnOptions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("i", {
        class: "fas fa-angle-left btn-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reject')))
      }),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.trailerStatusTitle), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.trailerStatusSubtitle), 1),
      _createVNode(_component_TrailerWithWarning, { class: "trailer-svg" }),
      _createElementVNode("div", _hoisted_6, " Trailer #" + _toDisplayString(_ctx.trailerNumber), 1),
      _createElementVNode("div", {
        class: "dispatcher-text",
        innerHTML: _ctx.detailsDescription
      }, null, 8, _hoisted_7)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_ReturnOptions, { "in-modal": true })
    ])
  ]))
}